import { primaryTextColor } from 'src/utils/Style/Theme';
import { style } from 'typestyle';

export const styles = style({
  display: 'grid',
  gridTemplateRows: '10% 40% 5% 45%',
  height: '100%',
  width: '100%',
  $nest: {
    '& .collection-info': {
      display: 'flex',
      $nest: {
        img: {
          objectFit: 'contain',
          height: '100%',
          minHeight: 0,
          flex: 1,
        },
        '.internal-info-container': {
          display: 'flex',
          flexDirection: 'column',
          flex: 4,
          width: '100%',
          marginLeft: '1rem',
        },
        '.labels': {
          padding: '0.5rem 0',
        },
        '.label': {
          marginBottom: '0.5rem',
        },
        '.macros': {
          height: '100%',
        },
        '[data-qa="key-financials"]': {
          flexWrap: 'wrap',
        },
        '.key-financial-item': {
          width: 'auto',
          padding: '0.5rem 1rem',
        },
        // TODO: these styles were initially a direct copy from choiceProductivityStyle, some styles have been modified to work in this view
        // abstract + consolidate these styles
        '.choice-productivity-container': {
          display: 'flex',
          $nest: {
            '&.print': {
              height: 'auto',
            },
            '.fin-wrapper': {
              display: 'flex',
              alignItems: 'center',
              minWidth: 200,
              // override key financial item styles when rendered in choice productivity
              $nest: {
                '.key-financial-item': {
                  backgroundColor: 'white',
                },
                header: {
                  fontWeight: 300,
                },
                '.primary': {
                  color: primaryTextColor,
                  flex: 'none',
                  marginRight: '1rem',
                },
              },
            },
            '.choice-wrapper': {
              flex: 1,
              display: 'flex',
              flexWrap: 'wrap',
              $nest: {
                '[data-qa="choice-item"]': {
                  // override default choiceProductivityStyle
                  width: 'auto',
                  padding: '0.5rem',
                },
              },
            },
          },
        },
        '.bottom-container': {
          height: 'auto',
        },
      },
    },
    '& header.items-header': {
      display: 'flex',
      alignItems: 'flex-end',
      fontWeight: '600',
    },
    '.detail-cards-container': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      overflowX: 'auto',
      $nest: {
        '& > button': {
          height: '40%',
        },
        '& .detail-cards': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
        '& .detail-cards .internal-card-container': {
          display: 'flex',
        },
        '[data-qa-component="StandardCard"]': {
          maxHeight: '305px',
          margin: '0 0.75rem',
        },
        '& .no-data': {
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        },
      },
    },
  },
});
